<template>
	<div class="cardItem">
		<div class="cardItem_text">
			<div class="cardItem_title">{{ cardTitle }}</div>
			<p class="cardItem_desc" v-html="cardDesc"></p>
			<div class="link">
				<page-link-button :link="pageLink" />
			</div>
		</div>
		<div class="cardItem_img">
			<img :src="contentsImage" />
		</div>
	</div>
</template>

<script>
import PageLinkButton from '@/components/common/PageLinkButton.vue';

export default {
	name: 'card-item',
	components: {
		PageLinkButton,
	},
	props: {
		cardTitle: String,
		cardDesc: String,
		cardImg: String,
		pageLink: String,
		contentsImage: String,
	},
};
</script>

<style lang="scss" scoped>
.cardItem {
	margin-top: 70px;
	@media print, screen and (min-width: 1161px) {
		margin-top: 95px;
		display: flex;
		justify-content: space-between;
		transform: translateX(30px);
		padding-left: 95px;
	}
	&.is-reverse {
		@media print, screen and (min-width: 1161px) {
			flex-direction: row-reverse;
			justify-content: flex-end;
			transform: translateX(-30px);
			gap: 80px;
			padding-left: 0;
			.cardItem_img {
				&::before {
					left: auto;
					right: -45px;
				}
			}
		}
	}
	&_text {
		position: relative;
		@media print, screen and (min-width: 1161px) {
			margin-top: 25px;
		}
	}
	&_title {
		font-size: 20px;
		line-height: calc(73 / 40);
		text-align: center;
		@media print, screen and (min-width: 1161px) {
			text-align: left;
			font-size: 26px;
		}
	}
	&_desc {
		font-size: 19px;
		line-height: calc(41 / 19);
		letter-spacing: 0;
		margin-top: 2em;
		@media print, screen and (max-width: 1160px) {
			text-align: center;
			margin-top: 1.5em;
			font-size: 15px;
			line-height: calc(73 / 29);
		}
		@media print, screen and (max-width: 520px) {
			text-align: left;
		}
	}
	&_img {
		position: relative;
		width: 100vw;
		margin: 40px calc(50% - 50vw) 0;
		@media print, screen and (min-width: 1161px) {
			width: 620px;
			margin: 0;
			&::before {
				content: '';
				width: 100px;
				height: 4px;
				background-color: #929292;
				display: block;
				position: absolute;
				top: 45px;
				left: -45px;
			}
		}
	}
}
.link {
	margin-top: 45px;
	@media print, screen and (max-width: 1160px) {
		margin-top: 30px;
		text-align: center;
	}
	@media print, screen and (max-width: 520px) {
		text-align: left;
	}
}
</style>
